import React, { useState } from "react";
import GcStudentMasterLayout from "../../../layouts/gcstudent/GcStudentMasterLayout";
import NotesPage from "../../../subsreens/gcstudent/notes/NotesPage";
import HeroSection from "../../../components/gcstudent/aboutsection/HeroSection";

const GcNotes = () => {
        const NotesData = { title: 'Notes', highLight: 'GGCW', subTitle: 'Browse and download study notes uploaded by staff across various departments.' };

    const [selectedNote, setSelectedNote] = useState(null);

    return <>
        <GcStudentMasterLayout>
            {!selectedNote && <HeroSection heroData={NotesData} />}
           <NotesPage selectedNote={selectedNote} setSelectedNote={setSelectedNote} />
        </GcStudentMasterLayout>
    </>
}

export default GcNotes;